export default __webpack_public_path__ + "static/big-marketo-3184fcba31d0b386f40ca7043fbf390b.png";